import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M8.917 16.582a1 1 0 001.165 0l7.322-5.25a1 1 0 00.367-1.124l-2.791-8.52A1 1 0 0014.03 1H4.97a1 1 0 00-.95.689l-2.792 8.519a1 1 0 00.368 1.124l7.321 5.25z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>);